import React from "react"
import Navbar from "./_nav/navbar"
import Footer from "./footer"
import { Script } from "gatsby"
import PageProgress from "./common/PageProgress"

const Layout = ({ children }) => {
  return (
    <div className="bg-gray">
      <Navbar
        social
        fancy
        navClassName="navbar navbar-expand-lg navbar-light navbar-bg-light caret position-absolute top-0"
      />
      <PageProgress />
      {children}
      <Footer />
      <Script
        type="text/javascript"
        charset="UTF-8"
        src="//cdn.cookie-script.com/s/3f6501c5fe8e92345ec6a7f01fb76f99.js"
        strategy="idle"
      />
    </div>
  )
}

export default Layout
